import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
//icons
import { BsSearch } from 'react-icons/bs';
//constants
import { choicesSearch, getContentProduct } from 'constants';
//components
import CustomInput from 'components/backoffice/customInput';
import SearchTable from 'components/backoffice/table/SearchTable';
import { SelectInputCustom } from 'components/input/index.js';


const FiltersTableProducts = ({ formFilter, setFormFilter, handleClear, t, page, setPage }) => {
  const contenidos = getContentProduct(t, true);

  const handleSearch = (e, key) => {
    if (page > 1 && e !== '') setPage(1);
    setFormFilter((prevFormFilter) => ({ ...prevFormFilter, [key]: e }));
  };

  return (
    <SearchTable multipleInput={true} handleClear={handleClear}>
      <Form className="d-flex flex-column flex-lg-row justify-content-between form-filter-list gap-3">
        <CustomInput
          handleKeyDown={true}
          type="text"
          placeholder={t('titulo')}
          value={formFilter.titulo}
          label={t('titulo')}
          onChange={(e) => handleSearch(e, 'titulo')}
        />
        <CustomInput
          handleKeyDown={true}
          type="text"
          placeholder={t('ean')}
          value={formFilter.ean}
          label={t('ean')}
          onChange={(e) => handleSearch(e, 'ean')}
        />
        <SelectInputCustom
          choices={contenidos}
          label={t('product.producttype')}
          onCheckedItem={(e) => handleSearch(e, 'type')}
          value={formFilter.type}
        />
      </Form>
    </SearchTable>
  );
};

FiltersTableProducts.propTypes = {
  formFilter: PropTypes.object,
  handleClear: PropTypes.func,
  setFormFilter: PropTypes.func,
  t: PropTypes.func,
  page: PropTypes.number,
  setPage: PropTypes.func
};

export default FiltersTableProducts;
